
// third-party
import { configureStore } from '@reduxjs/toolkit';
import { persistStore } from 'redux-persist';

// project import
import rootReducer from './reducer/rootReducer';

// ==============================|| REDUX TOOLKIT - MAIN STORE ||============================== //

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().filter((middleware) => middleware.name !== 'immutableStateInvariantMiddleware'),  // ImmutableStateInvariantMiddleware ko remove karna
});

// Extracting dispatch function from the store
const persistor = persistStore(store);

export { store, persistor };